/* eslint-disable max-lines */
import React, { ReactElement, memo } from "react";

function SmilingWithHeart(): ReactElement {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint0_radial_1656_104680)"
            />
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint1_radial_1656_104680)"
            />
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint2_radial_1656_104680)"
            />
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint3_radial_1656_104680)"
                fillOpacity="0.6"
            />
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint4_radial_1656_104680)"
            />
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint5_radial_1656_104680)"
            />
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint6_radial_1656_104680)"
            />
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint7_radial_1656_104680)"
            />
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint8_radial_1656_104680)"
            />
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint9_radial_1656_104680)"
            />
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint10_radial_1656_104680)"
            />
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint11_radial_1656_104680)"
            />
            <path
                d="M16 25C7 25 7 16 7 16H25C25 16 25 25 16 25Z"
                fill="url(#paint12_radial_1656_104680)"
            />
            <path
                d="M8 16.5V16H24V16.5C24 17.0523 23.5523 17.5 23 17.5H9C8.44772 17.5 8 17.0523 8 16.5Z"
                fill="url(#paint13_linear_1656_104680)"
            />
            <path
                d="M3.18104 9.75037C5.19703 12.0771 7.8791 13.096 9.25386 13.4894C9.81699 13.6506 10.4079 13.4889 10.8249 13.0776C12.0184 11.9005 14.4238 9.19933 14.938 6.11531C15.656 1.80872 10.256 0.495856 8.07985 4.04542C2.98933 1.65437 0.296489 6.42127 3.18104 9.75037Z"
                fill="url(#paint14_linear_1656_104680)"
            />
            <path
                d="M3.18104 9.75037C5.19703 12.0771 7.8791 13.096 9.25386 13.4894C9.81699 13.6506 10.4079 13.4889 10.8249 13.0776C12.0184 11.9005 14.4238 9.19933 14.938 6.11531C15.656 1.80872 10.256 0.495856 8.07985 4.04542C2.98933 1.65437 0.296489 6.42127 3.18104 9.75037Z"
                fill="url(#paint15_radial_1656_104680)"
            />
            <path
                d="M3.18104 9.75037C5.19703 12.0771 7.8791 13.096 9.25386 13.4894C9.81699 13.6506 10.4079 13.4889 10.8249 13.0776C12.0184 11.9005 14.4238 9.19933 14.938 6.11531C15.656 1.80872 10.256 0.495856 8.07985 4.04542C2.98933 1.65437 0.296489 6.42127 3.18104 9.75037Z"
                fill="url(#paint16_radial_1656_104680)"
            />
            <path
                d="M3.18104 9.75037C5.19703 12.0771 7.8791 13.096 9.25386 13.4894C9.81699 13.6506 10.4079 13.4889 10.8249 13.0776C12.0184 11.9005 14.4238 9.19933 14.938 6.11531C15.656 1.80872 10.256 0.495856 8.07985 4.04542C2.98933 1.65437 0.296489 6.42127 3.18104 9.75037Z"
                fill="url(#paint17_radial_1656_104680)"
            />
            <path
                d="M3.18104 9.75037C5.19703 12.0771 7.8791 13.096 9.25386 13.4894C9.81699 13.6506 10.4079 13.4889 10.8249 13.0776C12.0184 11.9005 14.4238 9.19933 14.938 6.11531C15.656 1.80872 10.256 0.495856 8.07985 4.04542C2.98933 1.65437 0.296489 6.42127 3.18104 9.75037Z"
                fill="url(#paint18_radial_1656_104680)"
            />
            <path
                d="M3.18104 9.75037C5.19703 12.0771 7.8791 13.096 9.25386 13.4894C9.81699 13.6506 10.4079 13.4889 10.8249 13.0776C12.0184 11.9005 14.4238 9.19933 14.938 6.11531C15.656 1.80872 10.256 0.495856 8.07985 4.04542C2.98933 1.65437 0.296489 6.42127 3.18104 9.75037Z"
                fill="url(#paint19_radial_1656_104680)"
            />
            <path
                d="M3.18104 9.75037C5.19703 12.0771 7.8791 13.096 9.25386 13.4894C9.81699 13.6506 10.4079 13.4889 10.8249 13.0776C12.0184 11.9005 14.4238 9.19933 14.938 6.11531C15.656 1.80872 10.256 0.495856 8.07985 4.04542C2.98933 1.65437 0.296489 6.42127 3.18104 9.75037Z"
                fill="url(#paint20_radial_1656_104680)"
            />
            <path
                d="M3.18104 9.75037C5.19703 12.0771 7.8791 13.096 9.25386 13.4894C9.81699 13.6506 10.4079 13.4889 10.8249 13.0776C12.0184 11.9005 14.4238 9.19933 14.938 6.11531C15.656 1.80872 10.256 0.495856 8.07985 4.04542C2.98933 1.65437 0.296489 6.42127 3.18104 9.75037Z"
                fill="url(#paint21_radial_1656_104680)"
            />
            <path
                d="M3.18104 9.75037C5.19703 12.0771 7.8791 13.096 9.25386 13.4894C9.81699 13.6506 10.4079 13.4889 10.8249 13.0776C12.0184 11.9005 14.4238 9.19933 14.938 6.11531C15.656 1.80872 10.256 0.495856 8.07985 4.04542C2.98933 1.65437 0.296489 6.42127 3.18104 9.75037Z"
                fill="url(#paint22_radial_1656_104680)"
            />
            <path
                d="M3.18104 9.75037C5.19703 12.0771 7.8791 13.096 9.25386 13.4894C9.81699 13.6506 10.4079 13.4889 10.8249 13.0776C12.0184 11.9005 14.4238 9.19933 14.938 6.11531C15.656 1.80872 10.256 0.495856 8.07985 4.04542C2.98933 1.65437 0.296489 6.42127 3.18104 9.75037Z"
                fill="url(#paint23_radial_1656_104680)"
            />
            <path
                d="M3.18104 9.75037C5.19703 12.0771 7.8791 13.096 9.25386 13.4894C9.81699 13.6506 10.4079 13.4889 10.8249 13.0776C12.0184 11.9005 14.4238 9.19933 14.938 6.11531C15.656 1.80872 10.256 0.495856 8.07985 4.04542C2.98933 1.65437 0.296489 6.42127 3.18104 9.75037Z"
                fill="url(#paint24_radial_1656_104680)"
            />
            <path
                d="M3.18104 9.75037C5.19703 12.0771 7.8791 13.096 9.25386 13.4894C9.81699 13.6506 10.4079 13.4889 10.8249 13.0776C12.0184 11.9005 14.4238 9.19933 14.938 6.11531C15.656 1.80872 10.256 0.495856 8.07985 4.04542C2.98933 1.65437 0.296489 6.42127 3.18104 9.75037Z"
                fill="url(#paint25_radial_1656_104680)"
            />
            <path
                d="M3.18104 9.75037C5.19703 12.0771 7.8791 13.096 9.25386 13.4894C9.81699 13.6506 10.4079 13.4889 10.8249 13.0776C12.0184 11.9005 14.4238 9.19933 14.938 6.11531C15.656 1.80872 10.256 0.495856 8.07985 4.04542C2.98933 1.65437 0.296489 6.42127 3.18104 9.75037Z"
                fill="url(#paint26_radial_1656_104680)"
            />
            <path
                d="M3.18104 9.75037C5.19703 12.0771 7.8791 13.096 9.25386 13.4894C9.81699 13.6506 10.4079 13.4889 10.8249 13.0776C12.0184 11.9005 14.4238 9.19933 14.938 6.11531C15.656 1.80872 10.256 0.495856 8.07985 4.04542C2.98933 1.65437 0.296489 6.42127 3.18104 9.75037Z"
                fill="url(#paint27_radial_1656_104680)"
            />
            <path
                d="M28.8174 9.75112C26.8023 12.0767 24.1217 13.0952 22.7474 13.4886C22.1842 13.6497 21.5933 13.4881 21.1763 13.0768C19.9832 11.8999 17.5791 9.20009 17.0652 6.11754C16.3475 1.8127 21.7453 0.500375 23.9205 4.0485C29.009 1.65842 31.7007 6.42338 28.8174 9.75112Z"
                fill="#CB0C4C"
            />
            <path
                d="M28.8174 9.75112C26.8023 12.0767 24.1217 13.0952 22.7474 13.4886C22.1842 13.6497 21.5933 13.4881 21.1763 13.0768C19.9832 11.8999 17.5791 9.20009 17.0652 6.11754C16.3475 1.8127 21.7453 0.500375 23.9205 4.0485C29.009 1.65842 31.7007 6.42338 28.8174 9.75112Z"
                fill="url(#paint28_radial_1656_104680)"
            />
            <path
                d="M28.8174 9.75112C26.8023 12.0767 24.1217 13.0952 22.7474 13.4886C22.1842 13.6497 21.5933 13.4881 21.1763 13.0768C19.9832 11.8999 17.5791 9.20009 17.0652 6.11754C16.3475 1.8127 21.7453 0.500375 23.9205 4.0485C29.009 1.65842 31.7007 6.42338 28.8174 9.75112Z"
                fill="url(#paint29_linear_1656_104680)"
            />
            <path
                d="M28.8174 9.75112C26.8023 12.0767 24.1217 13.0952 22.7474 13.4886C22.1842 13.6497 21.5933 13.4881 21.1763 13.0768C19.9832 11.8999 17.5791 9.20009 17.0652 6.11754C16.3475 1.8127 21.7453 0.500375 23.9205 4.0485C29.009 1.65842 31.7007 6.42338 28.8174 9.75112Z"
                fill="url(#paint30_radial_1656_104680)"
            />
            <path
                d="M28.8174 9.75112C26.8023 12.0767 24.1217 13.0952 22.7474 13.4886C22.1842 13.6497 21.5933 13.4881 21.1763 13.0768C19.9832 11.8999 17.5791 9.20009 17.0652 6.11754C16.3475 1.8127 21.7453 0.500375 23.9205 4.0485C29.009 1.65842 31.7007 6.42338 28.8174 9.75112Z"
                fill="url(#paint31_radial_1656_104680)"
            />
            <path
                d="M28.8174 9.75112C26.8023 12.0767 24.1217 13.0952 22.7474 13.4886C22.1842 13.6497 21.5933 13.4881 21.1763 13.0768C19.9832 11.8999 17.5791 9.20009 17.0652 6.11754C16.3475 1.8127 21.7453 0.500375 23.9205 4.0485C29.009 1.65842 31.7007 6.42338 28.8174 9.75112Z"
                fill="url(#paint32_radial_1656_104680)"
            />
            <path
                d="M28.8174 9.75112C26.8023 12.0767 24.1217 13.0952 22.7474 13.4886C22.1842 13.6497 21.5933 13.4881 21.1763 13.0768C19.9832 11.8999 17.5791 9.20009 17.0652 6.11754C16.3475 1.8127 21.7453 0.500375 23.9205 4.0485C29.009 1.65842 31.7007 6.42338 28.8174 9.75112Z"
                fill="url(#paint33_radial_1656_104680)"
            />
            <path
                d="M28.8174 9.75112C26.8023 12.0767 24.1217 13.0952 22.7474 13.4886C22.1842 13.6497 21.5933 13.4881 21.1763 13.0768C19.9832 11.8999 17.5791 9.20009 17.0652 6.11754C16.3475 1.8127 21.7453 0.500375 23.9205 4.0485C29.009 1.65842 31.7007 6.42338 28.8174 9.75112Z"
                fill="url(#paint34_radial_1656_104680)"
            />
            <path
                d="M28.8174 9.75112C26.8023 12.0767 24.1217 13.0952 22.7474 13.4886C22.1842 13.6497 21.5933 13.4881 21.1763 13.0768C19.9832 11.8999 17.5791 9.20009 17.0652 6.11754C16.3475 1.8127 21.7453 0.500375 23.9205 4.0485C29.009 1.65842 31.7007 6.42338 28.8174 9.75112Z"
                fill="url(#paint35_radial_1656_104680)"
            />
            <path
                d="M28.8174 9.75112C26.8023 12.0767 24.1217 13.0952 22.7474 13.4886C22.1842 13.6497 21.5933 13.4881 21.1763 13.0768C19.9832 11.8999 17.5791 9.20009 17.0652 6.11754C16.3475 1.8127 21.7453 0.500375 23.9205 4.0485C29.009 1.65842 31.7007 6.42338 28.8174 9.75112Z"
                fill="url(#paint36_radial_1656_104680)"
            />
            <path
                d="M28.8174 9.75112C26.8023 12.0767 24.1217 13.0952 22.7474 13.4886C22.1842 13.6497 21.5933 13.4881 21.1763 13.0768C19.9832 11.8999 17.5791 9.20009 17.0652 6.11754C16.3475 1.8127 21.7453 0.500375 23.9205 4.0485C29.009 1.65842 31.7007 6.42338 28.8174 9.75112Z"
                fill="url(#paint37_radial_1656_104680)"
            />
            <defs>
                <radialGradient
                    id="paint0_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(25.5 9) rotate(132.839) scale(37.5033)"
                >
                    <stop stopColor="#FFF478" />
                    <stop offset="0.474827" stopColor="#FFB02E" />
                    <stop offset="1" stopColor="#F70A8D" />
                </radialGradient>
                <radialGradient
                    id="paint1_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(25.5 9) rotate(131.878) scale(38.9487)"
                >
                    <stop stopColor="#FFF478" />
                    <stop offset="0.474827" stopColor="#FFB02E" />
                    <stop offset="1" stopColor="#F70A8D" />
                </radialGradient>
                <radialGradient
                    id="paint2_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16 12.5) rotate(101.31) scale(17.8466 22.8581)"
                >
                    <stop offset="0.787821" stopColor="#F59639" stopOpacity="0" />
                    <stop offset="0.972509" stopColor="#FF7DCE" />
                </radialGradient>
                <radialGradient
                    id="paint3_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(18 14) rotate(135) scale(41.0122)"
                >
                    <stop offset="0.314853" stopOpacity="0" />
                    <stop offset="1" />
                </radialGradient>
                <radialGradient
                    id="paint4_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16 17) rotate(77.692) scale(28.1469)"
                >
                    <stop offset="0.507903" stopColor="#7D6133" stopOpacity="0" />
                    <stop offset="1" stopColor="#715B32" />
                </radialGradient>
                <radialGradient
                    id="paint5_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16.5 16.5) rotate(55.7131) scale(13.3135 9.65032)"
                >
                    <stop stopColor="#FFB849" />
                    <stop offset="1" stopColor="#FFB847" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint6_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(20.5 18) rotate(9.86581) scale(11.6726)"
                >
                    <stop stopColor="#FFA64B" />
                    <stop offset="0.900412" stopColor="#FFAE46" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint7_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(17.5 15) rotate(43.9708) scale(59.0529)"
                >
                    <stop offset="0.185425" stopOpacity="0" />
                    <stop offset="1" stopOpacity="0.4" />
                </radialGradient>
                <radialGradient
                    id="paint8_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(5.0453 9.67886) rotate(35.4031) scale(6.89818 3.60263)"
                >
                    <stop stopColor="#CE5635" />
                    <stop offset="1" stopColor="#CE5635" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint9_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(18.5321 6.21577) rotate(57.7713) scale(3.92783)"
                >
                    <stop stopColor="#DF7536" />
                    <stop offset="1" stopColor="#DF7536" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint10_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(19.654 8.17074) rotate(62.5467) scale(6.11889 3.84245)"
                >
                    <stop stopColor="#DF7536" />
                    <stop offset="1" stopColor="#DF7536" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint11_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(19.4995 8.91665) rotate(49.834) scale(6.42182 4.06028)"
                >
                    <stop stopColor="#DF7536" />
                    <stop offset="1" stopColor="#DF7536" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint12_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16 27) rotate(-90) scale(11 22)"
                >
                    <stop stopColor="#F70A8D" />
                    <stop offset="1" stopColor="#89029C" />
                </radialGradient>
                <linearGradient
                    id="paint13_linear_1656_104680"
                    x1="16"
                    y1="16"
                    x2="16"
                    y2="17.5"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#ECCDFF" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient
                    id="paint14_linear_1656_104680"
                    x1="24.0041"
                    y1="3.33759"
                    x2="21.8701"
                    y2="14.2017"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#CA0B4A" />
                    <stop offset="1" stopColor="#F70A8D" />
                </linearGradient>
                <radialGradient
                    id="paint15_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(7.02927 12.6167) rotate(16.6992) scale(4.76329 2.12853)"
                >
                    <stop stopColor="#D6246F" />
                    <stop offset="1" stopColor="#D6246F" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint16_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(4.88845 10.9672) rotate(33.5535) scale(4.67451 2.0477)"
                >
                    <stop stopColor="#D6246F" />
                    <stop offset="1" stopColor="#D6246F" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint17_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(2.59015 8.31174) rotate(51.7817) scale(5.65781 1.12685)"
                >
                    <stop stopColor="#D6246F" />
                    <stop offset="1" stopColor="#D6246F" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint18_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(2.17528 8.29395) rotate(58.4957) scale(1.78688 0.433485)"
                >
                    <stop stopColor="#A41B36" />
                    <stop offset="1" stopColor="#A41B36" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint19_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(1.90014 6.65253) rotate(75.0124) scale(1.92886 0.404891)"
                >
                    <stop stopColor="#A41B36" />
                    <stop offset="1" stopColor="#A41B36" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint20_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(2 5.18082) rotate(90) scale(1.47644 0.448179)"
                >
                    <stop stopColor="#A41B36" />
                    <stop offset="1" stopColor="#A41B36" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint21_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(2.05079 4.41452) rotate(91.2259) scale(2.37382 0.720582)"
                >
                    <stop stopColor="#A41B36" />
                    <stop offset="1" stopColor="#A41B36" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint22_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(3.03974 3.93431) rotate(116.065) scale(1.18125 0.358572)"
                >
                    <stop stopColor="#A41B36" />
                    <stop offset="1" stopColor="#A41B36" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint23_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(8.00827 10.55) rotate(39.4337) scale(4.13536 2.60399)"
                >
                    <stop stopColor="#F944A5" stopOpacity="0.69" />
                    <stop offset="1" stopColor="#F944A5" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint24_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(11.0618 7.31985) rotate(111.882) scale(4.30139 1.61579)"
                >
                    <stop stopColor="#E63277" />
                    <stop offset="1" stopColor="#E63277" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint25_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(7.47168 5.93265) rotate(46.1088) scale(3.62264 2.00742)"
                >
                    <stop offset="0.194665" stopColor="#EC6686" />
                    <stop offset="1" stopColor="#EC6686" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint26_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(12.5143 4.37061) rotate(107.745) scale(2.63118 2.06562)"
                >
                    <stop stopColor="#F87797" />
                    <stop offset="1" stopColor="#EB6385" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint27_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(8.1074 3.80682) rotate(71.0992) scale(3.2833 0.566645)"
                >
                    <stop stopColor="#CE2356" />
                    <stop offset="1" stopColor="#DE265D" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint28_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(22.6668 4.68158) rotate(56.0304) scale(3.73239 2.34474)"
                >
                    <stop offset="0.363657" stopColor="#EC6686" />
                    <stop offset="1" stopColor="#EC6686" stopOpacity="0" />
                </radialGradient>
                <linearGradient
                    id="paint29_linear_1656_104680"
                    x1="24.171"
                    y1="5.19879"
                    x2="23.2339"
                    y2="5.03815"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.308486" stopColor="#CB0C4C" />
                    <stop offset="1" stopColor="#CB0C4C" stopOpacity="0" />
                </linearGradient>
                <radialGradient
                    id="paint30_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(22.287 10.4339) rotate(49.9555) scale(7.5548 4.75717)"
                >
                    <stop stopColor="#F944A5" stopOpacity="0.69" />
                    <stop offset="1" stopColor="#F944A5" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint31_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(23.9753 3.7391) rotate(97.2889) scale(2.44055 0.421203)"
                >
                    <stop stopColor="#CE2356" />
                    <stop offset="1" stopColor="#DE265D" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint32_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(26.0581 7.32156) rotate(130.989) scale(4.5923 1.72507)"
                >
                    <stop stopColor="#E63277" />
                    <stop offset="1" stopColor="#E63277" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint33_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(27.5251 5.94773) rotate(137.878) scale(2.72734 1.5626)"
                >
                    <stop stopColor="#F87797" />
                    <stop offset="1" stopColor="#EB6385" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint34_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(21.1201 12.6733) rotate(31.4346) scale(2.78808 1.24588)"
                >
                    <stop stopColor="#D6246F" />
                    <stop offset="1" stopColor="#D6246F" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint35_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(18.972 10.5914) rotate(45.8212) scale(4.1255 1.8072)"
                >
                    <stop stopColor="#D6246F" />
                    <stop offset="1" stopColor="#D6246F" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint36_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(17.6171 7.25366) rotate(65.4042) scale(5.16089 1.02788)"
                >
                    <stop stopColor="#D6246F" />
                    <stop offset="1" stopColor="#D6246F" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint37_radial_1656_104680"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(27.0634 10.074) rotate(117.896) scale(3.9331 3.66908)"
                >
                    <stop stopColor="#F944A5" stopOpacity="0.69" />
                    <stop offset="1" stopColor="#F944A5" stopOpacity="0" />
                </radialGradient>
            </defs>
        </svg>
    );
}

export default memo(SmilingWithHeart);
